export const PAGE_SIZE = 36;

export const MAIN_FILTER_VALUES = [
  'label',
  'gamma_dog',
  'gamma_capybara',
  'gamma_cat',
  'skin_type',
  'type_of_cosmetic',
  'problems',
  'age',
  'application_area',
  'sun_protection_factor',
  'otdushka',
  'brand'
];
